import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import * as tracker from 'presentations/views/helpers/analytics';

import { ViewerItem } from 'presentations/api/schema/user';
import {
  dashboardPath,
  loginPath,
  onboardPath,
} from 'presentations/routes/path';
import {
  authorize,
  fetchSession,
  setTracking,
} from 'presentations/views/helpers/auth/session';

export const localUserCacheKey = 'localUser';

export const useSinglePageApp = () => {
  const [viewer, setViewer] = useState<ViewerItem | null>(null);
  const [errorStatusCode, setErrorStatusCode] = useState<number | null>(null);

  const router = useRouter();

  useEffect(() => {
    fetchViewer();
  }, []);

  const fetchViewer = async () => {
    try {
      const result = await fetchSession();
      if (result.status === 403) {
        setErrorStatusCode(result.status);
        return;
      }
      const user: ViewerItem | null = result.data;
      if (user) {
        setTracking(user);
      }
      if (!user) {
        window.location.href = loginPath({
          to: dashboardPath(),
          locale: router.locale,
        });
        return;
      }
      if (user.isTemporary) {
        window.location.href = loginPath({
          to: dashboardPath(),
          locale: router.locale,
          isDefaultStepJoinTeam: true,
        });
        return;
      }
      if (!user.name && router.pathname !== onboardPath()) {
        window.location.href = onboardPath();
        return;
      }
      setViewer(user);
    } catch (error) {
      console.debug(error);
    }
  };

  const trackPage = useCallback(
    (url: string) => {
      if (!router) return;
      tracker.pageview(url);
    },
    [router],
  );

  useEffect(() => {
    router.events.on('routeChangeComplete', trackPage);
    return () => {
      router.events.off('routeChangeComplete', trackPage);
    };
  }, [router]);

  return {
    state: {
      viewer: viewer || null,
      errorStatusCode,
    },
    actions: {},
  };
};
